import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getAllPrice } from '../../lib/apis';
import axios from 'axios';
import { MarketPriceInterface } from '../../lib/Interfaces/MarketPrice';
import Market_price from '../../components/Market_price';

function Beancur() {
    const { t, i18n } = useTranslation()
    const [loader, setLoader] = useState(true)
    const scrollRef = useRef<HTMLDivElement>(null);
    const [market, setMarket] = useState<MarketPriceInterface[]>([])
    const [isScrolling, setIsScrolling] = useState(false);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const scrollAmountRef = useRef(0);
    const [isHovered, setIsHovered] = useState(false);

    const updateMarket = async () => {
        try {
            const { data } = await axios.get(getAllPrice)
            setMarket(data.result)
        } catch (error) {
            console.log("error", error)
        } finally {
            setLoader(false)
        }
    }

    useEffect(() => {
        updateMarket()
    }, [])

    const stopScrolling = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
        setIsScrolling(false);
    };

    const startScrolling = () => {
        const container = scrollRef.current;
        if (!container) return;

        // Vérifier si le contenu dépasse la largeur du conteneur
        const contentWidth = container.scrollWidth;
        const containerWidth = container.clientWidth;
        
        // Si le contenu ne dépasse pas, ne pas démarrer le défilement
        if (contentWidth <= containerWidth) {
            return;
        }

        // Réinitialiser la position si on est arrivé au bout
        if (scrollAmountRef.current >= contentWidth - containerWidth) {
            scrollAmountRef.current = 0;
            container.scrollLeft = 0;
        }

        setIsScrolling(true);
        intervalRef.current = setInterval(() => {
            if (!container) return;
            
            scrollAmountRef.current += 1;
            container.scrollLeft = scrollAmountRef.current;

            // Quand on arrive au bout, remettre au début pour un défilement infini
            if (scrollAmountRef.current >= container.scrollWidth - container.clientWidth) {
                scrollAmountRef.current = 0;
                container.scrollLeft = 0;
            }
        }, 40); // Augmenter l'intervalle pour un défilement plus fluide
    };

    // Démarrer le défilement quand les données sont chargées
    useEffect(() => {
        if (!loader && market.length > 0) {
            // Petit délai pour s'assurer que le DOM est mis à jour
            setTimeout(() => {
                startScrolling();
            }, 100);
        }
        return () => stopScrolling();
    }, [loader, market]);

    // Vérifier et redémarrer le défilement quand la fenêtre change de taille
    useEffect(() => {
        const handleResize = () => {
            if (!isHovered) {
                stopScrolling();
                setTimeout(() => startScrolling(), 100);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [isHovered]);

    const handleMouseEnter = () => {
        setIsHovered(true);
        stopScrolling();
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
        if (!loader && market.length > 0) {
            setTimeout(() => startScrolling(), 200);
        }
    };

    // Pour les écrans tactiles
    const handleTouchStart = () => {
        stopScrolling();
    };

    const handleTouchEnd = () => {
        if (!isHovered && !loader && market.length > 0) {
            setTimeout(() => startScrolling(), 1000);
        }
    };

    return (
        <div className='flex h-[48px] w-full flex-row items-center justify-between overflow-hidden border-b border-primary/10 bg-[#f7faf6] py-1'>
            <div className='flex w-full items-center'>
                <div className="hidden w-[10%] flex-shrink-0 items-center md:flex">
                    <h1 className="ml-3 border-l-2 border-primary pl-2 font-sans text-[11px] font-bold uppercase tracking-wider text-gray-600">{t("dernier_prix")}</h1>
                </div>
                <div
                    ref={scrollRef}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onTouchStart={handleTouchStart}
                    onTouchEnd={handleTouchEnd}
                    className="m-auto w-full max-w-[400px] cursor-pointer overflow-x-auto overflow-y-hidden scrollbar-hide md:max-w-[99vw]"
                    style={{
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                        whiteSpace: 'nowrap',
                        WebkitOverflowScrolling: 'touch',
                    }}
                >
                    {loader ? (
                        <div className='text-black'>{t("chargment")}...</div>
                    ) : (
                        <div className="flex flex-row gap-x-3 px-2" style={{ display: 'inline-flex' }}>
                            {/* Dupliquer les éléments pour un effet de défilement infini */}
                            {[...market, ...market].map((fruit: MarketPriceInterface, index) => (
                                // eslint-disable-next-line react/jsx-pascal-case
                                <Market_price
                                    key={`${fruit.product_name}-${index}`}
                                    product_name={i18n.language === "fr" ? fruit.product_name : fruit.product_name_en}
                                    price={fruit.latest_price}
                                    market_name={i18n.language === "fr" ? fruit.market_name : fruit.market_name_en}
                                    arrondissement={i18n.language === "fr" ? fruit.arrondissement : fruit.arrondissement_en}
                                    uml={i18n.language === "fr" ? fruit.uml : fruit.uml_en}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Beancur